import { BannersTrayWithCta } from '../../../domain/banners-tray-with-cta';
import { CreateBannersWithCtaPageItemRequestApiModel, UpdateBannersWithCtaPageItemRequestApiModel } from '@cxb/editor-stb-api';
import { mapperPipe, remainderMapper } from 'osn-shared';
import {
  layoutMapperDomainToApi,
  nameLocalizedMapperDomainToApi,
  scheduledDateMapperDomainToApi,
  targetingMapperDomainToApi,
} from '../../mapping/create-tray-domain-to-api';
import { BannersWithCtaPageItemApiModel } from '@cxb/editor-stb-api/model/models';
import { TraySelectorType } from '../tray-selector/tray-selector.enum';
import {
  commonMapper,
  nameLocalizedMapperApiToDomain,
  scheduledDateMapperApiToDomain,
  targetingMapperApiToDomain,
} from '../../mapping/create-tray-api-to-domain';
import { BannersTrayWithCtaViewModel } from './banners-tray-with-cta.view-model';
import { TrayFormViewModelType } from '../view-model-common/view-model-type';
import {
  layoutMapper,
  nameLocalizedMapperDomainToViewModel,
  scheduledDateMapperDomainToViewModel,
  targetingMapper,
} from '../create-tray-screen/mapping/create-tray-domain-to-vm';
import {
  nameLocalizedMapperViewModelToDomain,
  scheduledDateMapperViewModelToDomain,
} from '../create-tray-screen/mapping/create-tray-vm-to-domain';

// 'BannersTrayWithCta'

/**
 * DOMAIN -> API
 */

export const mapBannersTrayWithCtaTrayDomainModelToApiModel = (
  item: BannersTrayWithCta,
  pageVersionId?: string,
  tenantId?: string
): CreateBannersWithCtaPageItemRequestApiModel & UpdateBannersWithCtaPageItemRequestApiModel => {
  const commonProperties = mapperPipe(
    item,
    nameLocalizedMapperDomainToApi,
    targetingMapperDomainToApi,
    scheduledDateMapperDomainToApi,
    layoutMapperDomainToApi
  );

  return remainderMapper(commonProperties, () => ({
    pageVersionId,
    feedId: item.feedId,
    backgroundImage: item.backgroundImage.id,
    headlineLocalized: item.headlineLocalized,
    descriptionLocalized: item.descriptionLocalized,
    ctaLabelLocalized: item.ctaLabelLocalized,
    limit: item.limit,
    tenantId,
  }));
};

/**
 * API -> DOMAIN
 */

export const mapBannersTrayWithCtaTrayApiModelToDomainModel = (pageItem: BannersWithCtaPageItemApiModel): BannersTrayWithCta => {
  return remainderMapper(
    mapperPipe(pageItem, commonMapper, nameLocalizedMapperApiToDomain, targetingMapperApiToDomain, scheduledDateMapperApiToDomain),
    () => ({
      type: 'BannersTrayWithCta',
      feedId: pageItem.feedId,
      limit: pageItem.limit,
      ctaLabelLocalized: pageItem.ctaLabelLocalized,
      descriptionLocalized: pageItem.descriptionLocalized,
      headlineLocalized: pageItem.headlineLocalized,
      backgroundImage: {
        id: pageItem.backgroundImage.id,
        name: pageItem.backgroundImage.originalName,
        publicUrl: pageItem.backgroundImage.publicUrl,
      },

      layout: TraySelectorType.MarketingCTAThreeCard,
    })
  );
};

/**
 * DOMAIN -> VIEWMODEL
 */

export const mapBannersTrayWithCtaTrayDomainModelToViewModel = (pageItem: BannersTrayWithCta): BannersTrayWithCtaViewModel => {
  const commonProperties = mapperPipe(
    pageItem,
    commonMapper,
    nameLocalizedMapperDomainToViewModel,
    targetingMapper,
    scheduledDateMapperDomainToViewModel,
    layoutMapper
  );

  return remainderMapper(commonProperties, () => ({
    type: TrayFormViewModelType.BannersTrayWithCta,
    limit: pageItem.limit,
    feedId: pageItem.feedId,
    backgroundImage: pageItem.backgroundImage,
    headlineLocalized: pageItem.headlineLocalized,
    descriptionLocalized: pageItem.descriptionLocalized,
    ctaLabelLocalized: pageItem.ctaLabelLocalized,
  }));
};

/**
 * VIEWMODEL -> DOMAIN
 */

export const mapBannersTrayWithCtaTrayViewModelToDomainModel = (vm: BannersTrayWithCtaViewModel): BannersTrayWithCta => {
  const commonProperties = mapperPipe(
    vm,
    commonMapper,
    nameLocalizedMapperViewModelToDomain,
    targetingMapper,
    scheduledDateMapperViewModelToDomain,
    layoutMapper
  );

  return remainderMapper(commonProperties, () => ({
    type: 'BannersTrayWithCta',
    headlineLocalized: vm.headlineLocalized,
    descriptionLocalized: vm.descriptionLocalized,
    ctaLabelLocalized: vm.ctaLabelLocalized,
    backgroundImage: vm.backgroundImage,
    feedId: vm.feedId,
    limit: vm.limit,
  }));
};
